'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _dom = require('../common/dom.js');

var _dom2 = _interopRequireDefault(_dom);

var _magnificPopup = require('magnific-popup');

var _magnificPopup2 = _interopRequireDefault(_magnificPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var bindUIActions = function bindUIActions() {
  _dom2.default.$siteOverlay.on('click', function () {
    _dom2.default.$siteOverlay.removeClass('is-active');
  });

  _dom2.default.$hoverOverlay.on('click', function () {
    _dom2.default.$hoverOverlay.removeClass('is-active');
  });
};
// FIX: remove this import
var init = exports.init = function init() {
  bindUIActions();
};